import { IconProps } from "./IconProps";

export const MaintenanceIcon = (props: IconProps) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
    >
      <path
        d="M13.0261 6.35947C12.6961 6.02945 12.5311 5.86444 12.4693 5.67417C12.4149 5.5068 12.4149 5.32651 12.4693 5.15914C12.5311 4.96887 12.6961 4.80386 13.0261 4.47385L15.3914 2.10854C14.7638 1.82468 14.067 1.66666 13.3333 1.66666C10.5719 1.66666 8.33333 3.90523 8.33333 6.66666C8.33333 7.07586 8.38248 7.47357 8.47521 7.85423C8.57451 8.26186 8.62416 8.46567 8.61535 8.59443C8.60612 8.72923 8.58602 8.80095 8.52386 8.92092C8.46448 9.03551 8.35071 9.14927 8.12318 9.37681L2.91666 14.5833C2.22631 15.2737 2.22631 16.393 2.91666 17.0833C3.60702 17.7737 4.72631 17.7737 5.41666 17.0833L10.6232 11.8768C10.8507 11.6493 10.9645 11.5355 11.0791 11.4761C11.199 11.414 11.2708 11.3939 11.4056 11.3846C11.5343 11.3758 11.7381 11.4255 12.1458 11.5248C12.5264 11.6175 12.9241 11.6667 13.3333 11.6667C16.0948 11.6667 18.3333 9.42808 18.3333 6.66666C18.3333 5.93298 18.1753 5.23622 17.8914 4.60854L15.5261 6.97385C15.1961 7.30386 15.0311 7.46887 14.8408 7.53069C14.6735 7.58507 14.4932 7.58507 14.3258 7.53069C14.1355 7.46887 13.9705 7.30386 13.6405 6.97385L13.0261 6.35947Z"
        stroke="#06123D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
